export const MOBILE_HOME_MAX_WIDTH = 820;
